module.exports = __webpack_public_path__ + "img/unchecked-circle.91022f5a.svg";